import api from './api-v2';

const filter = async (filters) => {
    const client = await api.getClient();
    return await api.handleSuccess(await client.get('vms', { params: filters }));
};

// filter3 / getById3 read VMs from fleet's /api/v3 (clusters-fleet flag
// cutover, #4907). The v3 responses are shaped to core2's v2 contract
// server-side ({items, meta} envelope, bare detail record, nested cluster
// object), so these mirror filter/getById with the v3 client. The embedded
// cluster list passes clusterId as a first-class param instead of the v2
// `clusterId:=<id>` query syntax (fleet doesn't parse property filters).
const filter3 = async (filters) => {
    const client = await api.getClientV3();
    return await api.handleSuccess(await client.get('vms', { params: filters }));
};

const getById = async (id) => {
    const client = await api.getClient();
    const vm = await client.get(`vms/${id}`);
    return vm;
};

const getById3 = async (id) => {
    const client = await api.getClientV3();
    const vm = await client.get(`vms/${id}`);
    return vm;
};

const download = async (filters) => {
    const client = await api.getClient();
    return await client.get('vms/download', { params: filters, responseType: 'stream' }); // create file link in browser's memory
};

// download3 reads the CSV from fleet's /api/v3/vms/download (#5089). Only
// clusterId is forwarded, matching v2's effective filters (List.vue drops
// query; core2 ignores sort).
const download3 = async ({ clusterId } = {}) => {
    const client = await api.getClientV3();
    return await client.get('vms/download', { params: { clusterId }, responseType: 'blob' });
};

export default {
    getById,
    getById3,
    filter,
    filter3,
    download,
    download3,
};
